import {DesignCategoryType} from "./DesignCategoryType";
import {ICategoryProducts, IDesignFilter, IDesignCategory} from '../../interfaces';
import styles from './DesignCategory.module.css';
import {DesignProduct} from './DesignProduct';
import { DesignCatContext, useGlobalContext } from "../../lib/context";
import { useMemo, useState } from "react";
import dynamic from "next/dynamic";

type props={
    data:IDesignCategory;
}

export function CategoryProducts({data}:props){
    const DesignCategoryFilter=dynamic(()=>import('./DesignCategoryFilter').then(mod=>mod.DesignCategoryFilter),
    {
        ssr:false
    });
    const DesignFilter=dynamic(()=>import('./DesignFilter').then(mod=>mod.DesignFilter),
    {
        ssr:false
    });
    const {props:{countryCode, isMobileView}}=useGlobalContext();
    const [filterData] = useState<IDesignFilter[]>(data?.categoryProducts?.filterData || []);
    const [categoryProducts] = useState<ICategoryProducts>(data.categoryProducts);
    const [isMobileFilter,toggleMobileFilter]=useState(false);
    const [attributeSlug, setAttributeSlug]=useState(data.selectedAttributeSlug || data?.categoryProducts?.filterData[0]?.attributeSlug || "theme"); 
    const changeAttributeSlug=(slug:string)=>{
        if(attributeSlug==slug)
            setAttributeSlug("");
        else
            setAttributeSlug(slug);
    }

    const queryData: any = useMemo(() => {return {}}, []);
    const filterHandler=(valueSlug:string,isChecked:boolean,filterType:IDesignFilter)=>{                             
        let _queryData = JSON.parse(JSON.stringify(queryData)) || {};
        
        let _valueSlugs=_queryData[filterType.attributeSlug] || [];
        _valueSlugs['attributeId'] = filterType.attributeId;
        let _attributeValueSlug = _valueSlugs.attributeValueSlug || [];

        if (_attributeValueSlug.indexOf(valueSlug) === -1 && isChecked) {              
            _attributeValueSlug.push(valueSlug);            
            
            _valueSlugs.attributeValueSlug = _attributeValueSlug;
            _queryData[filterType.attributeSlug] = _valueSlugs;
        } else {    
            _attributeValueSlug = _attributeValueSlug.filter((f:string) => f != valueSlug);          

            if (_attributeValueSlug.length != 0) {
                _valueSlugs.attributeValueSlug = _attributeValueSlug;
                _queryData[filterType.attributeSlug] = _valueSlugs;
            } else {
                delete _queryData[filterType.attributeSlug];
            }
        }              
       
        _queryData = Object.fromEntries(Object.entries(_queryData).sort(([, a]:any, [, b]:any) => a.attributeId - b.attributeId));
        let queryDataKeys = Object.keys(_queryData);

        if(queryDataKeys.length == 0){
            const searchFilterURL=`interior-design-ideas/${data.categorySlug}`;
            return searchFilterURL;
        }
        
        let IsSearchPage = false;
        if (queryDataKeys.length >= 3)
            IsSearchPage = true;
        
        queryDataKeys.map((data) => { //attributes name           
            if (_queryData[data].attributeValueSlug.length >= 2)
                IsSearchPage = true;
        });

        if (!IsSearchPage) {            
            let FilterValueUrl=`interior-design-ideas/${data.categorySlug}/`;
            
            const _AttributeId: number[] = [];            
            queryDataKeys.map((values)=>{
                _AttributeId.push(_queryData[values].attributeId);
                
                FilterValueUrl += `${_queryData[values].attributeValueSlug[0].replaceAll('-','')}-`;
            });

            FilterValueUrl += `${filterType.categoryIdentifier}_${_AttributeId.join('_')}`;
            return FilterValueUrl;
        } else {
            let FilterValueUrl=`interior-design-ideas/search?category=${data.categorySlug}`;
            
            queryDataKeys.map((values)=>{
                FilterValueUrl += `&${values}=${_queryData[values]?.attributeValueSlug?.join('%2C')?.replaceAll('-','')}`;
            });
 
            return FilterValueUrl; 
        }
    }

    filterData.map((data) => {
        data.attributes.map((atr) => {
            const Data = queryData[data.attributeSlug];
            const AttributeData = {
                attributeValueSlug: Data && Data.attributeValueSlug || [],
                attributeId: data.attributeId,
            };

            const DoesIncludes = Data && Data.attributeValueSlug && Data.attributeValueSlug.find((data : string)=>data == atr.attributeValueSlug);

            if (atr.isChecked && !DoesIncludes) {
                AttributeData.attributeId = data.attributeId;
                AttributeData.attributeValueSlug.push(atr.attributeValueSlug);

                queryData[data.attributeSlug] = AttributeData;
            }
        })        
    });

    filterData.map((data) => {
        data.attributes = data.attributes.map((atr) => {
            const urlCombinationSlug = filterHandler(atr.attributeValueSlug, !atr.isChecked, data);            
            return { ...atr, urlCombinationSlug }
        })

        return data;
    });

    return (
        <DesignCatContext.Provider value= {
            {
                categorySlug:data.categorySlug,
                isMobileFilter,
                toggleMobileFilter,
                attributeSlug,
                changeAttributeSlug             
            }
            }>
            {!isMobileView ?
            <>
                <DesignCategoryType data={categoryProducts.categories} categorySlug={data.categorySlug} sticky={true} />
                <DesignCategoryFilter filterData={filterData} attributeSlug={data.selectedAttributeSlug || ""} /> 
                <DesignProduct data={categoryProducts} categorySlug={data.categorySlug} atrIdentifier={data.atrIdentifier} />                    
            </> :
            <div className={styles.modularSectnBx}>
                 <div className={styles.filterSectn}>
                    <DesignFilter data={filterData} />
                </div>
                <div className={styles.modularDetails}>       
                    <DesignCategoryType data={categoryProducts.categories} categorySlug={data.categorySlug} sticky={true} />
                    <DesignCategoryFilter filterData={filterData} attributeSlug={data.selectedAttributeSlug || ""} />          
                    <DesignProduct data={categoryProducts} categorySlug={data.categorySlug} atrIdentifier={data.atrIdentifier} />                    
                </div>
            </div>}
            {/* {filterData.length == 0  ? null : <div className={styles.floatingbtn} onClick={()=>toggleMobileFilter(true)} ><Image
                src="/assets/images/floating-filter.svg"
                height={20}
                width={16}
                alt="Filter"
                className="img-responsive"
                 /></div>} */}
        </DesignCatContext.Provider>
    );
}